module.exports = __webpack_public_path__ + "images/stickers/taco-proto.2e050937d34005636192.png";